var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6401 5.23596L14.7875 5.38889H15H17.1429C17.3212 5.38889 17.5 5.54774 17.5 5.77778C17.5 6.00782 17.3212 6.16667 17.1429 6.16667H6.85714C6.67884 6.16667 6.5 6.00782 6.5 5.77778C6.5 5.54774 6.67884 5.38889 6.85714 5.38889H9H9.21245L9.35992 5.23596L9.96849 4.60485C10.0316 4.53938 10.1258 4.5 10.2086 4.5H13.7914C13.8742 4.5 13.9684 4.53938 14.0315 4.60485L14.6401 5.23596ZM8.57143 19.5C7.9217 19.5 7.35714 18.9412 7.35714 18.2222V9.33333C7.35714 8.6144 7.9217 8.05556 8.57143 8.05556H15.4286C16.0783 8.05556 16.6429 8.6144 16.6429 9.33333V18.2222C16.6429 18.9412 16.0783 19.5 15.4286 19.5H8.57143Z",
    stroke: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1052 11.3684V16.421M13.8947 11.3684V16.421",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.b84ee813b374bb6d35e3f306b89a6c1b.svg";
export { ForwardRef as ReactComponent };